import React, { useState } from "react";
import Card from "../../../Components/share/cards/Card";
import AdminPagination from "../../../Components/share/Pageination/AdminPagination";
import { BtnAlternative } from "../../../Components/share/buttons/Btn";
import TableFilter from "../../share/Table/TableFilter/TableFilter";
import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";
import TableSort from "../../share/Table/TableSort/TableSort";

function AdminmessageTable(props) {
  const [idd, setIdd] = useState("");
  const { items, requestSort, sortConfig } = TableSort(props.list);
  const getClassNamesFor = (name) => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };
  return (
    <div className="mx-24 py-24">
      <Card className="SupportTicketTable-card SupportTicketTable-header ">
        {props.header.map((item, id) =>
          id === 1 ? (
            <div
              className={` flex flex-row items-center justify-center cursor-pointer text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem]`}
              onClick={() => {
                requestSort("date");
                setIdd(id);
              }}
              key={id}
            >
              {item.title}
              {sortConfig?.direction !== "ascending" && idd === id ? (
                <AiOutlineDown className=" mr-[0.3rem]" />
              ) : (
                <AiOutlineUp className=" mr-[0.3rem]" />
              )}
            </div>
          ) : id === 2 ? (
            <div
              className={` flex flex-row items-center justify-center cursor-pointer text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem]`}
              onClick={() => {
                requestSort("title");
                setIdd(id);
              }}
              key={id}
            >
              {item.title}
              {sortConfig?.direction !== "ascending" && idd === id ? (
                <AiOutlineDown className=" mr-[0.3rem]" />
              ) : (
                <AiOutlineUp className=" mr-[0.3rem]" />
              )}
            </div>
          ) : (
            <div className="text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem]">
              {item.title}
            </div>
          )
        )}
      </Card>

      {items.slice(props.tableStart, props.tableEnd).map((i, id) => (
        <Card
          key={i?.id}
          className="SupportTicketTable-card SupportTicketTable-body  my-4"
        >
          <div
            onClick={() => props.setMessageinfo(true)}
            className=" cursor-pointer"
          >
            {i?.name}
          </div>
          <div>{i?.date}</div>

          <div>{i?.title}</div>
          <div>
            <BtnAlternative
              text={"ارسال پاسخ"}
              className="px-10 py-6 self-center"
              onClick={() => props.setAnswer(true)}
            />
          </div>
        </Card>
      ))}
      <AdminPagination
        page={props.page}
        setPage={props.setPage}
        pageSize={5}
        className=" mt-[3rem]"
      />
      {props.children}
    </div>
  );
}

export default AdminmessageTable;
